<template>
    <div>
        <div uk-alert v-if="loginusername">
            <h3>{{ $t('Vor-Ort Ticketshop') }}</h3>
            <p class="uk-text-small">
                {{ $t('Eingeloggt als:') }} {{ loginusername }}
                <a data-request="onShopLogout" data-request-success="window.location.href = data.redirectUrl;">
                    {{ $t('Ausloggen') }}
                </a>
            </p>
        </div>
        <div v-if="store.state.loading"
             style="position:fixed;inset:0;z-index:2147483600;background:rgba(255,255,255,0.55);backdrop-filter:blur(2px);display:flex;align-items:center;justify-content:center;">
            <img src="/plugins/kosmoskosmos/festiware/assets/images/festiware_loading-spinner_v1.svg"
                 alt="Loading"
                 style="width:128px;height:128px"/>
        </div>
        <div v-if="hasErrors" class="uk-alert-danger uk-padding" uk-alert>
            <div class="uk-grid">
                <div class="uk-width-1-6">
                    <i uk-icon="icon:warning; ratio: 5"></i>
                </div>
                <div class="uk-width-3-4">
                    <h3>{{ errorHeadline || $t('Oh nein! Ein Fehler trat auf') }}</h3>
                    <p>
                        {{errorMessage}}
                    </p>
                </div>
            </div>
        </div>
        <div v-else-if="hasSuccess" class="uk-alert-success uk-padding" style="background-color:var(--color1); color:white" uk-alert>
            <div class="uk-grid">
                <div class="uk-width-1-6">
                    <i uk-icon="icon:happy; ratio: 5"></i>
                </div>
                <div>
                    <h3>{{$t('Vielen Dank für die Bestellung!')}}</h3>
                    <p>{{ $t("In Kürze sollte eine Bestätigungsmail eingehen. Bitte auch den Spam-Ordner überprüfen.") }}</p>
                    <div v-if="settings.outro_text" class="uk-margin-medium-bottom uk-margin-medium-top" v-html="settings.outro_text">
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="store.state.initialized" id="shop-wrapper" uk-grid>

            <div v-if="settings.showNav" class="uk-width-1-1" :class="{'uk-width-1-5@s': settings.twoColumns}">
                <navigation :current-step="store.state.currentStep" @updatePage="updatePage" :twoColumns="settings.twoColumns" :small="small"></navigation>
            </div>

            <div class="uk-width-expand@m uk-position-relative">
                <ul id="component-tab-left" class="uk-switcher" ref="switcher">
                    <li :class="{'uk-active': store.state.currentStep === 0, 'ticket-list': true}">
                        <ticket-list v-if="store.state.currentStep === 0" :settings="settings" :initialOfferId="initialOfferId" :preselectedCategory="preselectedCategory" :initialCouponCode="initialCouponCode" @next="next"/>
                    </li>
                    <li :class="{'uk-active': store.state.currentStep === 1, 'personalize': true}">
                        <personalize-tickets v-if="store.state.currentStep === 1" @next="next" @back="back" :settings="settings"/>
                    </li>
                    <li :class="{'uk-active': store.state.currentStep === 2, 'checkout': true}">
                        <checkout v-if="store.state.currentStep === 2" :settings="settings" :loginusername="loginusername" @next="next" @back="back"/>
                    </li>
                    <li :class="{'uk-active': store.state.currentStep === 3, 'order-summary': true}">
                        <order-summary v-if="store.state.currentStep === 3" :settings="settings" :loginusername="loginusername" @back="back"/>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import TicketList from "./tickets/TicketList";
import Checkout from "./checkout/Checkout";
import OrderSummary from "./summary/Summary";
import PersonalizeTickets from "./personalize/PersonalizeTickets";
import helper from "../helper/helper";
import Navigation from "./Navigation";
export default {
    mixins: [helper],
    props:  {
        lang: {type: String, default: 'de'},
        project: {type: String},
        loginusername: {type: String, default: ''},
        initialOfferId: {type: Number},
        preselectedCategory: {type: Number},
        initialCouponCode: {type: String, default: ''},
        fullDescription: {type: Boolean, default: false}
    },
    components: {Navigation, TicketList, Checkout, OrderSummary, PersonalizeTickets },
    data: () => {
        return {
            hasErrors: false,
            errorMessage: '',
            errorHeadline: '',
            hasSuccess: false,
            successMessage: '',
            settings: {},
            loading: false,
            serverError: false,
            direction: "left",
            currentStep: 0,
            initialized: false,
            scrollPosition: null,
            projectId: '',
            hideNav: {
                isHidden: true
            },
            small: false,
        };
    },
    mounted() {
        this.$root.$i18n.locale = this.lang
        this.$vueform.i18n.locale = this.lang;
        // Ticket.vue haengt zu tief, um die Prop durchgereicht zu bekommen —
        // der Store ist der Weg dorthin. Muss vor onGetSettings gesetzt sein,
        // damit die Ticketliste beim ersten Rendern schon den Wert sieht.
        this.store.state.fullDescription = this.fullDescription;
        if (document.body.clientWidth < 960) {
            this.small = true;
        }
        window.onresize = function(event) {
            this.small = document.body.clientWidth < 960;
        };
        if (this.orderstatus) {
            this.store.state.loading = false
            return
        }
        this.projectId = this.project;
        this.doOctoberRequest("onGetSettings", {}).then(response => {
            if (typeof response.code == 'undefined') {
                this.settings = response;
                window.projectId = response.project;
                this.store.commit("init", {settings: this.settings, doOctoberRequest: this.doOctoberRequest, $t: this.$t, initialCouponCode: this.initialCouponCode});
                this.initialized = true;

                if (this.settings.google_tag_id || this.settings.meta_pixel_id || (this.settings.matomo_site_id && this.settings.matomo_url)) {
                    this.initCookieConsent();
                }
            } else if (response.code == 404) {
                this.emitError('server', this.$t("Dieser Shop wurde nicht gefunden."), false, this.$t('Fehler'))
            } else if (response.code == 410) {
                this.emitError('server', this.$t("Dieser Shop ist zurzeit nicht aktiv."), false, this.$t('Fehler'))
            } else {
                this.emitError('server', this.$t("Entschuldigung, der Server meldet einen Fehler. Bitte versuche es später noch einmal."))
            }
        }).catch(error => {
            this.emitError('server', this.$t("Entschuldigung, der Server meldet einen Fehler. Bitte versuche es später noch einmal."))
            console.log(error)
        }).finally(() => {
            this.store.state.loading = false;
        })

        window.addEventListener('Festiware::Error', this.handleErrors)
        window.addEventListener('Festiware::Success', this.handleSuccess)
        window.addEventListener("scroll", this.updateScroll);
    },
    unmounted() {
        window.removeEventListener('Festiware::Error', this.handleErrors);
        window.removeEventListener('Festiware::Success', this.handleSuccess);
        window.removeEventListener("scroll", this.updateScroll);
    },
    methods: {
        back(steps = 1) {
            this.store.state.currentStep -= steps;
            if (this.store.state.currentStep > 0 && Object.keys(this.store.state.selection).length) {
                this.updatePage();
            }
	        this.store.commit('emitScroll');
        },
        next(steps = 1) {
            this.store.state.currentStep += steps;
            this.updatePage();
	        this.store.commit('emitScroll');
        },
        updatePage(setPage) {
            this.store.state.currentStep = setPage !== undefined ? setPage : this.store.state.currentStep;
            this.$scrollTo(this.$.appContext.app._container, 500, { offset: -120 });
            this.store.commit("updateSession");
        },
        updateScroll() {
            this.scrollPosition = window.scrollY;
        },
        handleErrors(payload) {
            if (payload.detail.onlyNotification) {
                UIkit.notification({
                    message: payload.detail.message,
                    status: 'danger',
                    pos: 'top-center',
                    timeout: 5000
                });
            } else {
                this.hasErrors = true;
                this.errorMessage = payload.detail.message;
                this.errorHeadline = payload.detail.errorHeadline;
            }
        },
        handleSuccess(payload) {
            this.hasSuccess = true;
            this.successMessage = payload.detail.message;
            this.store.commit("removeCookieStore", this.doOctoberRequest);
        },
        initCookieConsent() {
            const loadTracking = () => {
                if (this.settings.google_tag_id && typeof window.loadGoogleAnalytics === 'function') {
                    window.loadGoogleAnalytics(this.settings.google_tag_id);
                }
                if (this.settings.meta_pixel_id && typeof window.loadMetaPixel === 'function') {
                    window.loadMetaPixel(this.settings.meta_pixel_id);
                }
                if (this.settings.matomo_site_id && this.settings.matomo_url && typeof window.loadMatomo === 'function') {
                    window.loadMatomo(this.settings.matomo_url, this.settings.matomo_site_id);
                }
            };

            const isAllowed = window.top !== window.self || (typeof CookieConsent !== "undefined" && CookieConsent.acceptedCategory('analytics'));
            if (isAllowed) {
                loadTracking();
            }

            window.onConsentAnalytics = loadTracking;
        },
    },
};
</script>
